/**
 * FRIDGE-1087 — plain article text with its filter numbers linked.
 *
 * The editorial template extracts an article's tables and FAQ answers to plain
 * text before rendering, so the body linker (lib/filters/article-part-links.ts)
 * cannot reach them as HTML. The page computes the segments on the server
 * (`segmentFilterNumbers`) and this renders them: each filter number a link to
 * its filter-number page, the genuine cartridge's FFN chip beside it, the rest
 * as the exact text it was. No segments → the text, unchanged. No hooks, so it
 * renders in server and client components alike.
 */
import { Fragment } from 'react'
import Link from 'next/link'
import type { PartLinkSegment } from '@/lib/filters/article-part-links'

export function PartLinkedText({ text, segments }: { text: string; segments?: PartLinkSegment[] | null }) {
  if (!segments || segments.length === 0) return <>{text}</>
  return (
    <>
      {segments.map((s, i) =>
        s.href ? (
          <Fragment key={i}>
            <Link href={s.href} prefetch={false} className="part-link" data-part-link={s.code}>
              {s.text}
            </Link>
            {s.ffn ? (
              <span className="part-link__ffn" title={`Fridge.com Filter Number of the genuine ${s.brand ?? ''} ${s.code ?? ''} cartridge`.replace(/\s+/g, ' ')}>
                {s.ffn}
              </span>
            ) : null}
          </Fragment>
        ) : (
          <Fragment key={i}>{s.text}</Fragment>
        )
      )}
    </>
  )
}
